import Compressor from "compressorjs";
import { getFromStorage } from "../constants/storage";
import { API_URL, END_POINTS } from "../constants/url";
import { STORAGE_KEYS } from "../constants/storageKeys";

interface UploadResponse {
  statusCode: number;
  data: string;
  message: string;
}

const getUploadHeaders = async (): Promise<Record<string, string>> => {
  const getToken = await getFromStorage(STORAGE_KEYS.token);
  let token = null;
  if (getToken) {
    try {
      token = JSON.parse(`${getToken}`);
    } catch {
      token = getToken;
    }
  }
  return {
    Accept: "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
};

export const UploadMedia = (imageObject: any): Promise<UploadResponse> => {
  return new Promise(async (resolve, reject) => {
    new Compressor(imageObject, {
      quality: 0.6,
      success: async (compressedResult) => {
        const formData = new FormData();
        formData.append("image", compressedResult as any);

        try {
          const headers = await getUploadHeaders();
          const res = await fetch(API_URL + END_POINTS.upload, {
            method: "POST",
            headers,
            body: formData,
          });
          let response = await res.json();
          resolve(response);
        } catch (error) {
          console.log(error, ">>>>>>>>>");
          reject(error);
        }
      },
    });
  });
};

export const UploadVideo = (imageObject: any): Promise<UploadResponse> => {
  return new Promise(async (resolve, reject) => {
    const formData = new FormData();
    formData.append("image", imageObject as any);

    try {
      const headers = await getUploadHeaders();
      const res = await fetch(API_URL + END_POINTS.upload, {
        method: "POST",
        headers,
        body: formData,
      });
      let response = await res.json();
      resolve(response);
    } catch (error) {
      console.log(error, ">>>>>>>>>");
      reject(error);
    }
  });
};

export const Uploadpdf = async (imageObject: any) => {
  console.log("imageObject, ", imageObject);

  const formData = new FormData();

  formData.append("media", imageObject as any);

  const getToken = await getFromStorage(STORAGE_KEYS.token);
  const token = getToken ? JSON.parse(`${getToken}`) : null;
  let headers = {
    Accept: "application/json",
    Authorization: "Bearer " + token,
  };
  try {
    const res = await fetch(API_URL + END_POINTS.upload, {
      method: "POST",
      headers,
      body: formData,
    });
    let response = await res.json();
    return response;
  } catch (error) {
    console.log(error, ">>>>>>>>>");
    return error;
  }
};
